import React, { useEffect, useState } from 'react';
import { Container, Alert, Button } from 'react-bootstrap';
import axiosInstance from '../api/axiosInstance';
import LeaderboardList from '../components/LeaderboardList';
import './Leaderboard.css';

const LeaderboardPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchData = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await axiosInstance.get('/checkins/top-global?limit=10');
      setItems(Array.isArray(response.data?.data) ? response.data.data : []);
    } catch (err) {
      console.error('Failed to fetch global leaderboard', err);
      setError('無法載入全站排行榜，請稍後再試。');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Container className="leaderboard-page py-4 py-md-5">
      <section className="leaderboard-hero">
        <p className="leaderboard-hero-kicker">Pet Buddy Club</p>
        <h1>全站排行榜 Top 10</h1>
        <p>依據全站簽到次數統計，看看目前最活躍的用戶。</p>
      </section>

      {loading ? (
        <div className="leaderboard-loading">排行榜載入中...</div>
      ) : error ? (
        <Alert variant="danger" className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-2">
          <span>{error}</span>
          <Button variant="outline-danger" size="sm" onClick={fetchData}>重新載入</Button>
        </Alert>
      ) : (
        <LeaderboardList title="全站簽到排名" items={items} emptyText="目前尚無簽到資料" />
      )}
    </Container>
  );
};

export default LeaderboardPage;
